import { createStyles, makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) => {
  return createStyles({
    title: {
      fontSize: '12px',
      fontWeight: 600,
      marginTop: theme.spacing(2),
      textTransform: 'uppercase',
      color: theme.palette.grey['A700'],
    },
    chip: {
      marginRight: theme.spacing() / 2,
      marginTop: theme.spacing() / 2,
      marginBottom: theme.spacing() / 2,
      fontSize: '12px',
      lineHeight: '12px',
    },
  });
});
